import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '../../../services/snackbar.service';
import { 
  CodigosLerMaterialControllerService,
  CvfMermasControllerService,
  OperacionGestionControllerService,
  CvfMaterialesCodLerControllerService,
  AgrupacionMaterialControllerService
 } from 'api-rest';

export interface DialogData {
  materialesDisponibles: any[];
  materialesUsados: string[];
  materialesUsadosIds?: number[];
  isMerma?: boolean;
  combinacionId?: number;
  codigoLerId?: number;
}

@Component({
  selector: 'lib-holders-cvf-material-dialog',
  templateUrl: './holders-cvf-material-dialog.component.html',
  styleUrls: ['./holders-cvf-material-dialog.component.scss']
})
export class HoldersCvfMaterialDialogComponent implements OnInit {
  selectedCodigoLer: any = null;
  selectedAgrupacion: any = null;
  selectedMermaOperation: any = null;
  
  fullList: any[] = [];
  uniqueCodigoLerList: any[] = [];
  filteredAgrupacionList: any[] = [];
  mermaOperationsList: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<HoldersCvfMaterialDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private codigosLerMaterialControllerService: CodigosLerMaterialControllerService,
    private cvfMermasControllerService: CvfMermasControllerService,
    private operacionGestionControllerService: OperacionGestionControllerService,
    private cvfMaterialesCodLerService: CvfMaterialesCodLerControllerService,
    private agrupacionMaterialControllerService: AgrupacionMaterialControllerService,
    private snackbarSrv: SnackbarService,
  ) {}

  ngOnInit(): void {
    if (this.data.isMerma) {
        const filter: any = {};
        this.operacionGestionControllerService.findAll7(filter, { page: 0, size: 1000 }).subscribe({
             next: (response: any) => {
                 this.mermaOperationsList = response?.datos || response || [];
             },
        });
        return;
    }

    const filter: any = {
      codigoLer: {
        id: this.data.codigoLerId
      },
      visible: true
    };
    
    const usedIds = this.data.materialesUsadosIds || [];

    this.codigosLerMaterialControllerService.findAll18(filter, { page: 0, size: 1000 }).subscribe({
      next: (response: any) => {
        const relations = response?.datos || response || [];
        
        const materialsMap = new Map<number, any>();
        
        relations.forEach((rel: any) => {
             const mat = rel.agrupacionMaterial;
             if (mat && mat.id) {
                 if (!materialsMap.has(mat.id) && !usedIds.includes(mat.id)) {
                     materialsMap.set(mat.id, mat);
                 }
             }
        });
        
        this.filteredAgrupacionList = Array.from(materialsMap.values());
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAccept(): void {
    if (this.data.isMerma) {
        if (!this.selectedMermaOperation) return;
        
        const payload: any = {
             cvfCodLerOperacion: this.data.combinacionId,
             operacionGestion: this.selectedMermaOperation.id,
             cantidadMerma: 0
        };

        const request: any = payload ;

        this.cvfMermasControllerService.create5(request).subscribe({
            next: (res: any) => {
                 if (res) {
                     res.operacionGestion = this.selectedMermaOperation;
                 }
                 this.dialogRef.close(res);
            },
            error: (err) => {
                 if (err && (err.status === 500 || (err.error && err.error.status === 500))) {
                     this.snackbarSrv.showSnackBar('Esta merma ya está asignada para este conjunto de código LER y operación de gestión', 'error');
                 } else {
                     this.dialogRef.close(null);
                 }
            }
        });
        
    } else if (this.selectedAgrupacion) {
      const payload: any = {
          cvfCodLerOperacion: this.data.combinacionId,
          agrupacionMaterial: this.selectedAgrupacion.agrupacionMaterial?.id || this.selectedAgrupacion.id
      };

      this.cvfMaterialesCodLerService.create6(payload).subscribe({
          next: (res: any) => {
              if (res && this.selectedAgrupacion) {
                  if (!res.agrupacionMaterial) {
                      res.agrupacionMaterial = this.selectedAgrupacion;
                  } else {
                      if (!res.agrupacionMaterial.descripcion) {
                          res.agrupacionMaterial.descripcion = this.selectedAgrupacion.descripcion || this.selectedAgrupacion.agrupacionMaterial?.descripcion;
                      }
                      if (!res.agrupacionMaterial.codigo) {
                          res.agrupacionMaterial.codigo = this.selectedAgrupacion.codigo || this.selectedAgrupacion.agrupacionMaterial?.codigo;
                      }
                  }
              }
              this.dialogRef.close(res);
          },
          error: (err) => {
              this.dialogRef.close(null); 
          }
      });
    } else {
      this.dialogRef.close(null);
    }
  }
}
